import gql from "graphql-tag";

export const updateCoordinatorById = gql`
  mutation UpdateCoordinatorById($data: UserUpdateInput!, $id: ID!) {
    updateUser(data: $data, where: { id: $id }) {
      id
    }
  }
`;